module.exports = __webpack_public_path__ + "img/paytm.d14f6f85.svg";